import ReactPaginate from "react-paginate";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import Item from 'components/FlujosEstructure/Item';
import { ITEMS_BY_PAGE_OPTIONS } from "constants/pagination";

function Table({
  flujosEstructure = [],
  getFlujosEstructure,
  deleteFlujoEstructure,
  totalPages,
  setPage,
  page,
  isSearched,
  setIsSearched,
  allFlujosEstructure = [],
  itemsPerPage,
  setItemsPerPage,
  hasSearched,
  resetSearch,
}){
 let myAbilities = HelpAbility();
 const {search, option, state} = isSearched;

 console.log({flujosEstructure})
 const handlePageClick = (data) => {
  state ? getFlujosEstructure({page: data.selected + 1, [option]: search}) : getFlujosEstructure({page: data.selected + 1})  ;
 };

 const resetFlujosStructure = async () => {
    resetSearch();
    setPage(1);
    getFlujosEstructure({});
 };

 const onItemsPerPageChange = (e) => {
    const newItemsPerPage = e.target.value;
    setItemsPerPage(newItemsPerPage);
    state ? getFlujosEstructure ({page: 1, limit: newItemsPerPage, [option]: search}) : getFlujosEstructure  ({page: 1, limit: newItemsPerPage});
  }

 return (
  <div className="mt-4">
   <div className="row mb-2">
    <div className="col d-flex align-items-end">
     <h6>Flujos registrados</h6>
    </div>
    <div className="col d-flex justify-content-end"> 
      <div className="d-flex flex-row gap-3">
        <div className="col d-flex flex-row align-items-center gap-2">
          <label htmlFor="items-by-page" className="form-label mb-0">Mostrar: </label>
          <select 
            onChange={onItemsPerPageChange} 
            className="form-select form-select-sm" 
            aria-label="Default select example" 
            name="items-by-page" 
            style={{width: '70px'}} 
            value={itemsPerPage}
          >
          {
            ITEMS_BY_PAGE_OPTIONS.map((value, index, arr) => {
                if((allFlujosEstructure?.length ?? 0) <= arr?.[index - 1]) return null;
                return (
                    <option 
                        value={value} 
                        key={'item-by-page-option-' + value}
                    >
                        {value}
                    </option>
                )
            })
          }            
          </select>
        </div>
        <button type="submit" className="btn btn-primary" onClick={resetFlujosStructure} disabled={!hasSearched}>Limpiar búsqueda</button>
      </div>
   </div>
   </div>
   <div className="table-responsive rounded-3" style={{border: '1px solid black'}}>
    <table className="table">
     <thead>
      <tr>
          <th scope="col" className="text-center">#</th>
          <th scope="col" className="text-center">Flujo Barrio Manzana</th>
          <th scope="col" className="text-center">Predeterminado</th>
          {myAbilities.hasAny([C.A.FLUJOSSTRUCTURE.UPDATE, C.A.FLUJOSSTRUCTURE.DELETE]) && 
          <th scope="col" className="text-center">Acción</th>}
      </tr>
     </thead>
     <tbody>
     {(allFlujosEstructure.filter(flu => flu.predeterminado === true).length) 
        ?
            allFlujosEstructure.filter(flu => flu.predeterminado === true).map((flujo, i) => <Item 
                key={flujo._id}  
                i={i - 1} 
                flujo={flujo} 
                deleteFlujoEstructure={deleteFlujoEstructure}
                predet={true}
                
            />) 
        :
        ""
     }

     {
        flujosEstructure.length ? 
        flujosEstructure.map((flujo, i) => <Item 
            key={flujo._id}  
            i={i} 
            flujo={flujo} 
            deleteFlujoEstructure={deleteFlujoEstructure}
        />)
        :
        <tr>
            <td colSpan="5">Sin datos</td>
        </tr>
     }
     </tbody>
    </table>
   </div>
   <div>
       <ReactPaginate
           previousLabel={"Anterior"}
           nextLabel={"Siguiente"}
           breakLabel={"..."}
           pageCount={totalPages}
           //Cuantas paginas quieres mostrar despues de los 3 ...
           marginPagesDisplayed={1}
           //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
           pageRangeDisplayed={2}
           forcePage={page - 1}
           onPageChange={handlePageClick}
           containerClassName={"pagination justify-content-center mt-3"}
           pageClassName={"page-item"}
           pageLinkClassName={"page-link"}
           previousClassName={"page-item"}
           previousLinkClassName={"page-link"}
           nextClassName={"page-item"}
           nextLinkClassName={"page-link"}
           breakClassName={"page-item"}
           breakLinkClassName={"page-link"}
           activeClassName={"active"}
       />
   </div>
 </div>
 )
}

export default Table
